// import * as ModelClasses from './ModelClasses'
// Object.entries(ModelClasses).forEach( ( [k, klass ] ) => module.exports[k]=klass )

// NOTE TO DEVELOPERS - ONLY BUSINESS OBJECT CLASSES SHOULD BE EXPORTED FROM HERE
// this index forms the ModelClasses map which is used specically for generating instances by BusinessObjectAssember

/**
 * Make sure exports go to the **exact file** instead of an `index.ts`!
 */

export { Alert } from './Alert'
export { AlertTrigger } from './Incidents/AlertTrigger'
export { Area } from './Geo/Area'
export { BooleanRule } from './BooleanRule'
export { Customer } from './Customer'
export { Device } from './Device/Device'
export { DeviceControlTransaction } from './DeviceControl/DeviceControlTransaction'
export { DeviceHistory } from './DeviceControl/DeviceHistory'
export { DeviceMessage } from './Device/DeviceMessage'
export { Entity } from './Entity'
export { EntityProgramme } from './constructs/EntitySequentialProgrammes/EntityProgramme'
export { EntityProgrammeSet } from './constructs/EntitySequentialProgrammes/EntityProgrammeSet'
export { EntityRollingProgramme } from './constructs/EntityRollingProgrammes'
export { Gateway } from './Geo/Gateway'
export { GatewayData } from './GatewayData'
export { Geofence } from './Geo/Geofence'
export { GeofenceRule } from './GeofenceRule'
export { GeoModelCommon } from './Geo/GeoModelCommon'
export { GeoPoint } from './Geo/GeoPoint'
export { Group } from './Group'
export { Incident } from './Incidents/Incident'
export { LambdaFunction, DynamoDBTable } from './aws/AWSSystemComponents'
export { Location } from './Geo/Location'
export { MetricRule } from './MetricRule'
export { MobileDevice } from './MobileDevice'
export { NamedPoint } from './Geo/NamedPoint'
export { Notification } from './Notifications/Notification'
export { NotificationSubscription } from './Notifications/NotificationSubscription'
export { OnDemandProgramme } from './constructs/OnDemandProgramme/OnDemandProgramme'
export { OpenWeatherData } from './Weather'
export { Organization } from './Organization'
export { Path } from './Geo/Path'
export { Person } from './Person'
export { Place } from './Geo/Place'
export { PlaceStyler } from './Styler'
export { ProductModel } from './ProductModel'
export { Property } from './Property'
export { Region } from './Geo/Region'
export { Ruleset } from './Ruleset'
export { ScoreSet } from './Scoring/Score'
export { Supplier } from './Supplier'
export { Team } from './Team'
export { ThingShadowState } from './ThingShadowState'
export { User } from './User'
